export function getAll() {
  return [
    {
      value: 0,
      name: "Store",
      text: "同門市",
    },
    {
      value: 1,
      name: "Company",
      text: "全公司",
    },
  ];
}

export function getByValue(value) {
  const type = getAll().find(function (item) {
    return item.value == value;
  });
  return type;
}
